/* eslint-disable */
import {Service} from 'components/Shared/server';



export const routePostAdd = (productId: string) => `/api/favourite/${encodeURIComponent(productId)}`;
export function postAdd(productId: string): Promise<Response> {
  return Service.post<Response>({
    url: routePostAdd(productId),
    body: null
  });
}

export const routeDeleteRemove = (productId: string) => `/api/favourite/${encodeURIComponent(productId)}`;
export function deleteRemove(productId: string): Promise<Response> {
  return Service.remove<Response>({
    url: routeDeleteRemove(productId)
  });
}
